<template>
  <div style="height: 100%">
    <!--多回路-->
    <div style="padding-top: 15px;font-weight: bold;margin-left: 25px;margin-bottom: 10px;">
      <span
          style="width: 5px;height: 15px;border-left: 2px solid #299FFB;display: inline-block;margin-bottom: -2px;margin-right: 5px;"></span>
      <span>多回路</span>
    </div>
    <div class="switch-multi-loop-content">
      <el-scrollbar style="height: 100%; margin-top: 10px; margin-bottom: 10px" v-if="multiLoopContent.length > 0">
        <div :style="getMasterSwitch()" class="top-bar"></div>
        <!--        <div class="top-bar1" :style="getMasterSwitch()"></div>-->
        <!--        <div class="top-node1" :style="getMasterSwitchSpot()"></div>-->
        <!--        <div class="top-bar2" :style="getMasterSwitch()"></div>-->
        <!--        <div class="top-node2" :style="getMasterSwitchSpot()"></div>-->
        <!--        <div class="top-bar3" :style="getMasterSwitch()"></div>-->
        <!--        <div :style="verticalStyle" class="vertical-bar"></div>-->
        <div class="switchBox">
          <template v-for="(val, index) in multiLoopContent">
            <div :key="`vertical${val.id}${val.pointId}`" :style="verticalStyle(index)" class="vertical-bar"></div>
            <div :key="val.id+val.pointId" :style="getTop(index)" class="bar1"></div>
            <div :key="`node1${val.id}${val.pointId}`" :style="getNode1Top(index)" class="node1"></div>
            <div :key="`status${val.id}${val.pointId}`" :style="getStatusStyle(index, val)" class="status"></div>
            <div :key="`node2${val.id}${val.pointId}`" :style="getNode1Top(index)" class="node2"></div>
            <div :key="`bar2${val.id}${val.pointId}`" :style="getTop(index)" class="bar2"></div>
            <div :key="`names${val.id}${val.pointId}`" :style="getNamesStyle(index, val)" class="names">{{ val.pointName }}</div>
          </template>
        </div>
      </el-scrollbar>
      <no-data style="margin-top: 18%" v-else></no-data>
    </div>
  </div>
</template>

<script>

import {getHistoryBySpacePoint} from "../../../network/measuring-point-history";
import NoData from "@/components/NoData";

export default {
  name: "MultiLoop",
  props: {
    spaceId: {
      type: String,
      default: () => null
    }
  },
  watch: {
    spaceId() {
      this.getMultiLoopData();
    },
  },
  components: {NoData},
  data() {
    return {
      multiLoopContent: [],
      typeList: ["PM_DI"],
      pointCodes: [],
    }
  },
  mounted() {
    this.getMultiLoopData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', {'getMultiLoopData:10000': this.getMultiLoopData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getMultiLoopData')
  },
  methods: {
    getMultiLoopData: function () {
      getHistoryBySpacePoint({
        spaceId: this.spaceId,
        typeList: this.typeList,
        pointCodes: this.pointCodes
      }).then(res => {
        this.multiLoopContent = [];
        if (res.code === 0){
          if (res.data.length > 0){
            this.multiLoopContent = res.data[0].deviceInfoList[0].deviceMeasuringPointHistoryList;
          }
        }
      })
    },
    getMasterSwitch(){
      return `top: ${this.multiLoopContent.length * 20 - 4}px`;
    },
    getMasterSwitchSpot(){
      return `top: ${13 + this.multiLoopContent.length * 10}px`;
    },

    verticalStyle(index){
        return `height: ${4 + index * 40}px;
              top: 15px`;
    },
    getTop(index) {
      return `top: ${15 + index * 40}px`;
    },

    getNode1Top(index) {
      return `top: ${15 + index * 40 - 3}px`;
    },

    getStatusStyle(index, val) {
      if (val.status == 0) {
        return `
                    top: ${15 + index * 40}px;
                    transform-origin: 0% 50%;
                    transform: rotate(-45deg);
                `;
      } else {
        return `
                    top: ${15 + index * 40}px;
                    transform-origin: 0% 50%;
                    transform: rotate(0deg);
                `;
      }
    },
    getNamesStyle(index, val) {
      var style = '';
      style += `top: ${index * 40 + 0}px;`;
      if (val.value == 1) {
        style += 'color: #ffffff;';
      } else if (val.value == 0) {
        style += 'color: #f70505;';
      } else {
        style += 'color: #000;';
      }
      return style;
    },
  }
}
</script>

<style scoped>

.switch-multi-loop-content {
  height: 80%;
  position: relative;
  overflow: hidden;
  /*margin-top: -60px !important;*/
}

.top-bar {
  width: 65px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 40px;
  top: 50%;
}


.top-bar1 {
  width: 10px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 40px;
  top: 50%;
}

.top-node1 {
  width: 4px;
  height: 4px;
  border: 4px solid rgba(41, 159, 251, 1);
  border-radius: 50%;
  position: absolute;
  left: 50px;
  top: 49%;
}

.top-bar2 {
  width: 35px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 55px;
  top: 50%;
  transform-origin: 0% 50%;
  transform: rotate(-45deg);
}

.top-node2 {
  width: 2px;
  height: 4px;
  border: 4px solid rgba(41, 159, 251, 1);
  border-radius: 50%;
  position: absolute;
  left: 80px;
  top: 49%;
}

.top-bar3 {
  width: 15px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 86px;
  top: 50%;
}

.vertical-bar {
  width: 4px;
  height: 94%;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  top: 0;
  left: 100px;
}

.switchBox {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: absolute;
  left: 105px;
  top: 0;
}

.vertical-bar {
  width: 4px;
  height: 94%;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  top: 0;
  left: 0;
}

.bar1 {
  width: 45px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 0;
}

.node1 {
  width: 2px;
  height: 4px;
  border: 4px solid rgba(41, 159, 251, 1);
  border-radius: 50%;
  position: absolute;
  left: 45px;
}

.status {
  width: 30px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 50px;
}

.node2 {
  width: 2px;
  height: 4px;
  border: 4px solid rgba(41, 159, 251, 1);
  border-radius: 50%;
  position: absolute;
  left: 75px;
}

.bar2 {
  width: 50px;
  height: 4px;
  background: rgba(41, 159, 251, 1);
  position: absolute;
  left: 83px;
}

.names {
  width: 105px;
  height: 30px;
  line-height: 30px;
  color: #fff !important;
  background-color: rgba(41, 155, 255, .6);
  position: absolute;
  left: 135px;
  text-align: center;
  font-size: 0.9rem;
  border-radius: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


</style>
